module.exports = "data:image/svg+xml;base64,PHN2ZyBjbGFzcz0iaWNvbiIgdmlld0JveD0iMCAwIDEwMjQgMTAyNCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB3aWR0aD0iMTI4IiBoZWlnaHQ9IjEyOCI+PGRlZnM+PHN0eWxlLz48L2RlZnM+PHBhdGggZD0iTTAgNTI0LjhsMjgxLjYgMTY2LjRMODY0IDE2MCAzODQgNzA0bDM4NCAxMjhMMTAyNCAwem0zODQgNDYwLjhMNTEyIDgzMmwtMTI4LTY0eiIvPjwvc3ZnPg=="


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/sender.svg
// module id = kQcg
// module chunks = 72